<template>
  <ob-admin-section
    type="adminmaps"
    :xlsx="false"
    :add="true"
    :edit="true"
    :confirm-value="confirm.dialog"
    @getFile="_cbGetFile"
    @confirmed="_cbConfirmed"
    @showMap="setActiveMap"
    :show="showAdminSection">

    <template slot="section-title">Sectiune Harti Aplicatie</template>

    <template slot="toolbar-title">Baza de date Harti Aplicatie</template>

    <template slot="map">
      <!-- <v-dialog v-model="showMap" fullscreen hide-overlay transition="dialog-bottom-transition" style="background: #fff"> -->
        <div style="height: 75vh; position: relative" v-if="showMap">
          <v-toolbar height="84">
            <template v-slot:extension>
              (wip)
              <v-text-field @input="setBorderColor" :value="borderColor" type="color" label="Border" persistent-hint></v-text-field>
              <v-text-field @input="setBorderWeight" :value="borderWeight" type="number" :step="0.01" label="Weight" persistent-hint></v-text-field>
              <v-text-field @input="setBorderLightness" :value="borderLightness" type="number" :step="0.01" label="Lightness" persistent-hint></v-text-field>
            </template>
            <v-select :items="sheets" label="Sheet" v-model="selectedSheet"></v-select>
            <v-text-field @input="setZoom" :value="zoom" type="number" :step="0.01" label="Zoom" hint="Cam 8.5-9 pt A4" persistent-hint></v-text-field>
            <v-text-field @input="setScale" :value="scale" type="number" :step="0.01" label="Point scale" hint="Cam 1 pt A4" persistent-hint></v-text-field>
            <v-text-field @input="setPointOpacity" :value="pointOpacity" type="number" :step="0.01" :min="0.1" :max="1" label="Point opacity" persistent-hint></v-text-field>
            <v-text-field @input="setPointStroke" :value="pointStroke" type="number" :step="0.01" :min="0" label="Point stroke" persistent-hint></v-text-field>
            <v-text-field v-model.number="screenshotScale" type="number" :step="1" label="Screenshot scale" hint="Dimensiunile A4 * cu x" persistent-hint></v-text-field>
            <v-text-field @input="setLabelFontSize" :value="labelSize" type="number" :step="0.1" label="Label size" hint="Label font size (cam 32 pt A4)" persistent-hint></v-text-field>
            <v-switch
              v-model="labelColorLikePointColor"
              label="Culoare label"
              hide-details>
            </v-switch>
            <v-switch
              v-model="labels"
              label="Labels"
              hide-details>
            </v-switch>
            <v-btn icon @click="screenshot" :loading="screenshotLoading" :disabled="screenshotLoading">
              <v-icon color="primary">mdi-camera</v-icon>
            </v-btn>
            <v-btn icon @click="disableDefaultUI = !disableDefaultUI">
              <v-icon :color="!disableDefaultUI ? 'primary' : 'grey'">mdi-settings</v-icon>
            </v-btn>
          </v-toolbar>
          <GmapMap
            :center="mapCenter"
            :zoom="zoom"
            :style="{ width: '100%', height: 'calc(100% - 180px)' }"
            :options="{ styles: mapStyles, disableDefaultUI }"
            ref="map"
            id="map"
            class="elevation-3">
            <GmapMarker
              v-for="(point, index) in points"
              :key="index"
              :position="{lat: Number(point.lat), lng: Number(point.long)}"
              :clickable="true"
              :draggable="false"
              :animation="2"
              :icon="{
                path: 'M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0',
                fillColor: getColor(point.color),
                labelOrigin: { x: 0, y: 35 },
                fillOpacity: pointOpacity,
                anchor: { x: 0, y: 0 },
                strokeWeight: pointStroke,
                scale: scale
              }"
              :label="labels ? { text: point.denumire, color: labelColorLikePointColor ? getColor(point.color) : '#000', fontWeight: 'normal', fontSize: `${labelSize}px` } : ''"
              @click="pointClicked(point)">
            </GmapMarker>
            <gmap-info-window :position="activePoint ? {lat: Number(activePoint.lat), lng: Number(activePoint.long)} : mapCenter" :opened="!!activePoint" @closeclick="activePoint = null">
              <v-card v-if="!!activePoint" class="elevation-0">
                <v-card-title primary-title class="pa-0">
                  <div>
                    <h3 class="headline">{{activePoint.denumire}} - {{activePoint.judet}}</h3>
                    <div class="title"> {{ activePoint.value.toLocaleString('ro-RO') }} </div>
                    <div class="body-2"> {{ activePoint.text1 }} </div>
                    <div class="body-2"> {{ activePoint.text2 }} </div>
                  </div>
                </v-card-title>
              </v-card>
            </gmap-info-window>
          </GmapMap>

          <div class="map-title title" style="position: absolute; top: 180px; left: 0; text-align: center">
            ({{ legendTotal }}){{ title }}
          </div>
          <div class="view-map-legend body-2" style="min-width: 200px; position: absolute; bottom: 12px; left: 0; border: 1px solid #3e7fc2; color: #3e7fc2; background-color: rgba(247,247,247,0.75)">
            <table>
              <tr v-for="(color, index) in colors" :key="color" class="legend-item">
                <td>
                  <span class="legend-bullet mr-4" :style="{ 'background-color': color}" style="width: 20px; height: 20px"></span>
                </td>
                <td class="legend-count blue-grey--text pr-4" style="font-size: 12px">
                  {{ legendCount[index] }}
                </td>
                <td class="legend-label display-4 font-weight-bold" style="font-size: 12px !important">
                  {{ legendLabels[index] }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      <!-- </v-dialog> -->
    </template>
  </ob-admin-section>
</template>

<script>
import AdminSection from '@/components/AdminSection'
import Dialog from '@/components/Dialog'
import { mapStyles } from '@/constants/mapStyles'
// import html2canvas from 'html2canvas'
import debounce from 'lodash.debounce'

export default {
  name: 'admin-maps',
  components: {
    'ob-admin-section': AdminSection,
    'ob-dialog': Dialog
  },
  data: () => ({
    type: 'adminmaps',
    fab: null,
    confirm: {
      dialog: false,
      callback: null
    },
    selected: [],
    mapCenter: {
      lat: 46.03308197722126,
      lng: 24.905333289473706
    },
    zoom: 6.75,
    showMap: false,
    scale: 0.25,
    activePoint: null,
    screenshotScale: 1,
    showAdminSection: true,
    disableDefaultUI: true,
    screenshotLoading: false,
    showControls: true,
    mapId: null,
    labels: true,
    labelColorLikePointColor: false,
    labelSize: 12,
    sheets: [],
    allData: {},
    allColors: {},
    selectedSheet: null,
    pointOpacity: 1,
    pointStroke: 0,
    borderColor: '#2d93ed',
    borderWeight: '1',
    borderLightness: '41',

    allLegendCount: null,
    allLegendLabels: null,
    allTitle: null
  }),
  computed: {
    host () {
      return this.$store.getters.host
    },
    token () {
      return this.$store.getters['token']
    },
    tabs () {
      return this.$store.getters[`${this.type}/tabs`]
    },
    selectedTab () {
      return this.$store.getters[`${this.type}/selectedTab`]
    },
    selectedTabID () {
      return this.$store.getters[`${this.type}/selectedTabID`]
    },
    mapStyles () {
      const styles = [ ...mapStyles ]

      styles[5].stylers[0].weight = this.borderWeight
      styles[5].stylers[1].color = this.borderColor
      styles[5].stylers[2].lightness = this.borderLightness

      return styles
    },
    points () {
      if (this.selectedSheet) {
        return this.allData[this.selectedSheet]
      }
    },
    colors () {
      if (this.selectedSheet) {
        return this.allColors[this.selectedSheet]
      }
    },
    legendCount () {
      if (this.selectedSheet) {
        return this.allLegendCount[this.selectedSheet]
      }
    },
    legendLabels () {
      if (this.selectedSheet) {
        return this.allLegendLabels[this.selectedSheet]
      }
    },
    title () {
      if (this.selectedSheet) {
        return this.allTitle[this.selectedSheet]
      }
    },
    legendTotal () {
      if (this.selectedSheet) {
        return Object.keys(this.legendCount).reduce((sum, key) => {
          sum += this.legendCount[key]

          return sum
        }, 0)
      }
    }
  },
  methods: {
    _cbGetFile ($event) {
      fetch(`${this.host}/rest-getMapFile?file=${$event.file}`, {
        method: 'get',
        headers: new Headers({
          'Authorization': this.token
        })
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Server error...')
          }
          return response.blob()
        })
        .then(blob => {
          this.$store.commit(`${this.type}/setLoading`, false)
          var url = window.URL.createObjectURL(blob)
          var a = document.createElement('a')
          a.href = url
          a.target = '_blank'
          a.download = $event.file
          document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click()
          a.remove() // afterwards we remove the element again
        })
        .catch(err => {
          this.error = true
          this.$store.commit(`${this.type}/setLoading`, false)
          console.log(err)
        })
    },
    _cbConfirmed (value) {
      if (value && this.confirm.callback) this[this.confirm.callback]()
      this.confirm.dialog = false
      this.confirm.callback = null
    },
    setActiveMap ($event) {
      this.showMap = true
      this.sheets = Object.keys($event.payload.data)
      if (this.sheets.length) {
        this.selectedSheet = this.sheets[this.sheets.length - 1]
      }
      this.allColors = $event.payload.colors
      this.allData = $event.payload.data
      this.denumire = $event.payload.denumire
      this.mapId = $event.payload._id

      this.allLegendCount = $event.payload.legendCount
      this.allLegendLabels = $event.payload.legendLabels
      this.allTitle = $event.payload.title
    },
    pointClicked (point) {
      this.$set(this, 'activePoint', point)
    },
    getColor (value) {
      if (!isNaN(value)) {
        return this.colors[value] || '#000'
      } else {
        return value
      }
    },
    async screenshot () {
      this.screenshotLoading = true

      fetch(`${this.host}/rest-map-screenshot`, {
        method: 'post',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': this.token
        }),
        body: JSON.stringify({
          id: this.mapId,
          scale: this.scale,
          ssScale: this.screenshotScale,
          zoom: this.zoom,
          host: this.host,
          labels: this.labels ? 1 : 0,
          labelColor: this.labelColorLikePointColor ? 1 : 0,
          labelSize: this.labelSize,
          pointOpacity: this.pointOpacity,
          pointStroke: this.pointStroke,
          sheet: this.selectedSheet
        })
      })
        .then(res => res.json())
        .then(res => {
          this.screenshotLoading = false
          const a = document.createElement('a')
          a.href = 'data:image/png;base64,' + res.ss
          a.download = `${this.denumire}.png`
          a.click()
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.screenshotLoading = false
        })
    },

    setZoom: debounce(function (value) {
      this.zoom = Number(value)
    }, 500),
    setScale: debounce(function (value) {
      this.scale = Number(value)
    }, 500),
    setLabelFontSize: debounce(function (value) {
      this.labelSize = Number(value)
    }, 500),
    setPointOpacity: debounce(function (value) {
      this.pointOpacity = Number(value) < 0 ? 0 : (Number(value) > 1 ? 1 : Number(value))
    }, 500),
    setPointStroke: debounce(function (value) {
      this.pointStroke = Number(value) < 0 ? 0 : Number(value)
    }, 500),
    setBorderColor: debounce(function (value) {
      this.borderColor = value
    }, 500),
    setBorderWeight: debounce(function (value) {
      this.borderWeight = value
    }, 500),
    setBorderLightness: debounce(function (value) {
      this.borderLightness = value
    }, 500)
  },
  created () {
    this.$store.dispatch(`${this.type}/setEventWatchers`)
    this.$store.dispatch(`${this.type}/fetchHeaders`)
    this.$store.dispatch(`${this.type}/fetchItems`)
  }
}
</script>

<style>

</style>
